import { gql } from 'graphql-tag';

export const ACCOUNT_INFO = gql`
  subscription ($accountId: uuid!, $userId: uuid!){
    accounts_by_pk(id: $accountId) {
      id
      name
      active
      balance
      available_balance
      default_payment_source_id
      members(where: { user_id: { _eq: $userId }}) {
        user{
          profile{
            name
            email
            avatar
            phone
            phone_verified
          }
        }
      }
    }
  }
`;
